import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { useState as A, useRef as k, useEffect as E, forwardRef as D, useCallback as I } from "react";
import { Sparkles as N, ExternalLink as Y, X as U } from "lucide-react";
import { B as g } from "./Banner-BBfZio8n.js";
import { S as T } from "./Skeleton-BOboktJd.js";
import { B as S } from "./Button-icgr8OM9.js";
const G = {
  display: "flex",
  flexWrap: "wrap",
  gap: "var(--space-2)",
  alignItems: "center"
};
function P({
  isHot: l,
  sendDisabled: t,
  streaming: n,
  onSend: o,
  onRegenerate: i,
  onRewrite: a,
  sendLabel: u,
  regenerateLabel: d,
  rewriteLabel: s
}) {
  return /* @__PURE__ */ c("div", { style: G, children: [
    /* @__PURE__ */ e(
      S,
      {
        variant: l ? "danger" : "primary",
        size: "sm",
        onClick: o,
        disabled: t || n,
        children: u
      }
    ),
    /* @__PURE__ */ e(
      S,
      {
        variant: "ghost",
        size: "sm",
        onClick: i,
        disabled: n,
        iconLeft: /* @__PURE__ */ e(N, { "aria-hidden": !0, style: { width: "var(--icon-xs)", height: "var(--icon-xs)" } }),
        children: d
      }
    ),
    a ? /* @__PURE__ */ e(S, { variant: "ghost", size: "sm", onClick: a, disabled: n, children: s }) : null
  ] });
}
function w({ style: l, children: t }) {
  return /* @__PURE__ */ c("span", { style: l, children: [
    /* @__PURE__ */ e(N, { "aria-hidden": !0, style: { width: "var(--icon-sm)", height: "var(--icon-sm)" } }),
    t
  ] });
}
const R = 250, j = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0,0,0,0)",
  whiteSpace: "nowrap",
  border: 0
};
function $({ text: l, streaming: t }) {
  const [n, o] = A(""), i = k(0), a = k(null);
  return E(() => {
    if (!t) {
      a.current !== null && (clearTimeout(a.current), a.current = null), i.current = Date.now(), o(l);
      return;
    }
    const u = Date.now(), d = u - i.current;
    if (d >= R) {
      i.current = u, o(l);
      return;
    }
    if (a.current !== null) return;
    const s = R - d;
    a.current = setTimeout(() => {
      a.current = null, i.current = Date.now(), o(l);
    }, s);
  }, [l, t]), E(() => () => {
    a.current !== null && (clearTimeout(a.current), a.current = null);
  }, []), /* @__PURE__ */ e(
    "div",
    {
      "data-ls-component": "draft-stream-live-region",
      "data-streaming": t || void 0,
      role: "status",
      "aria-live": "polite",
      "aria-atomic": "false",
      style: j,
      children: n
    }
  );
}
const V = {
  display: "flex",
  gap: "var(--space-3)",
  alignItems: "center",
  fontSize: "var(--text-xs)",
  color: "var(--text-secondary)",
  marginTop: "var(--space-1)"
}, B = {
  background: "none",
  border: "none",
  padding: 0,
  font: "inherit",
  color: "var(--text-secondary)",
  cursor: "pointer",
  textDecoration: "underline",
  textUnderlineOffset: "2px"
};
function C({
  withExternalLinkIcon: l,
  onOpenInBarel: t,
  onDismiss: n,
  openInBarelLabel: o,
  dismissLabel: i
}) {
  return /* @__PURE__ */ c("div", { style: V, children: [
    t ? /* @__PURE__ */ c("button", { type: "button", style: B, onClick: t, children: [
      o,
      l ? /* @__PURE__ */ e(
        Y,
        {
          "aria-hidden": !0,
          style: {
            width: "var(--icon-xs)",
            height: "var(--icon-xs)",
            marginLeft: "var(--space-1)",
            verticalAlign: "-2px"
          }
        }
      ) : null
    ] }) : null,
    n ? /* @__PURE__ */ e("button", { type: "button", style: B, onClick: n, children: i }) : null
  ] });
}
const X = {
  width: "100%",
  minHeight: "96px",
  padding: "var(--space-3)",
  border: "1px solid var(--border-default)",
  borderRadius: "var(--radius-lg)",
  background: "var(--bg-base)",
  color: "var(--text-primary)",
  fontFamily: "var(--font-sans)",
  fontSize: "var(--text-sm)",
  lineHeight: "var(--line-md)",
  resize: "vertical",
  outline: "none"
}, K = D(
  function({ value: t, onChange: n, onKeyDown: o, ariaLabel: i, streaming: a }, u) {
    const [d, s] = A(!1), x = {
      ...X,
      borderColor: d ? "var(--accent-default)" : "var(--border-default)",
      boxShadow: d ? "0 0 0 2px var(--ring-focus)" : "none",
      opacity: a ? 0.85 : 1
    };
    return /* @__PURE__ */ e(
      "textarea",
      {
        ref: u,
        "data-ls-component": "draft-textarea",
        "data-streaming": a || void 0,
        "aria-label": i,
        value: t,
        onChange: n,
        onKeyDown: o,
        onFocus: () => s(!0),
        onBlur: () => s(!1),
        style: x
      }
    );
  }
);
K.displayName = "DraftTextarea";
const h = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--space-3)",
  padding: "var(--space-4)",
  background: "var(--bg-elevated)",
  border: "1px solid var(--border-default)",
  borderRadius: "var(--radius-xl)",
  boxShadow: "var(--shadow-lg)",
  fontFamily: "var(--font-sans)",
  color: "var(--text-primary)",
  fontSize: "var(--text-sm)",
  lineHeight: "var(--line-sm)",
  minWidth: "280px",
  maxWidth: "420px"
}, b = {
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--space-2)",
  fontWeight: "var(--font-weight-semibold)",
  fontSize: "var(--text-xs)",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  color: "var(--text-secondary)"
}, q = {
  ...b,
  color: "var(--error)"
}, J = {
  display: "flex",
  flexWrap: "wrap",
  gap: "var(--space-2)",
  margin: 0,
  padding: 0,
  listStyle: "none"
}, Q = {
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--space-1)",
  padding: "2px var(--space-2)",
  borderRadius: "var(--radius-full)",
  background: "var(--bg-base)",
  border: "1px solid var(--border-subtle)",
  fontSize: "var(--text-2xs)",
  color: "var(--text-secondary)"
}, Z = {
  background: "none",
  border: "none",
  padding: 0,
  font: "inherit",
  color: "var(--text-secondary)",
  cursor: "pointer",
  textDecoration: "underline",
  textUnderlineOffset: "2px"
}, ee = {
  position: "absolute",
  top: "var(--space-2)",
  right: "var(--space-2)",
  width: "24px",
  height: "24px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  background: "transparent",
  border: "none",
  color: "var(--text-tertiary)",
  cursor: "pointer",
  borderRadius: "var(--radius-sm)"
}, te = D(function({
  mode: t,
  draftText: n,
  signals: o,
  hotOverride: i = !1,
  offTarget: a = !1,
  expectedAccountName: u,
  streaming: d = !1,
  sendDisabled: s = !1,
  onChangeDraft: x,
  onSend: L,
  onRegenerate: z,
  onRewrite: H,
  onOpenInBarel: y,
  onDismiss: m,
  labels: r
}, v) {
  const f = t === "hot" || i, O = t === "review" || t === "hot", _ = k(null);
  E(() => {
    t === "review" && (i || _.current?.focus());
  }, [t, i]);
  const W = I(
    (p) => {
      x?.(p.target.value);
    },
    [x]
  ), F = I(
    (p) => {
      p.key === "Enter" && (p.metaKey || p.ctrlKey) && (p.preventDefault(), s || L?.());
    },
    [L, s]
  );
  return t === "cancelled" ? /* @__PURE__ */ e("div", { ref: v, "data-ls-component": "draft-panel", "data-mode": t, style: { ...h }, children: /* @__PURE__ */ e(g, { tone: "success", title: r?.cancelledTitle, children: r?.cancelledBody ?? null }) }) : t === "account-mismatch" ? /* @__PURE__ */ c("div", { ref: v, "data-ls-component": "draft-panel", "data-mode": t, style: { ...h }, children: [
    /* @__PURE__ */ c(g, { tone: "warning", title: r?.accountMismatchTitle, children: [
      r?.accountMismatchBody ?? null,
      u ? /* @__PURE__ */ e("div", { style: { marginTop: "var(--space-1)", fontWeight: "var(--font-weight-semibold)" }, children: u }) : null
    ] }),
    m ? /* @__PURE__ */ e(
      "button",
      {
        type: "button",
        "aria-label": r?.closeAriaLabel ?? "Dismiss",
        onClick: m,
        style: ee,
        children: /* @__PURE__ */ e(U, { "aria-hidden": !0, style: { width: "var(--icon-sm)", height: "var(--icon-sm)" } })
      }
    ) : null
  ] }) : t === "blocked" ? /* @__PURE__ */ c("div", { ref: v, "data-ls-component": "draft-panel", "data-mode": t, style: { ...h }, children: [
    /* @__PURE__ */ e(g, { tone: "warning", title: r?.blockedTitle, children: r?.blockedBody ?? null }),
    y ? /* @__PURE__ */ c("button", { type: "button", style: Z, onClick: y, children: [
      r?.openInBarel,
      /* @__PURE__ */ e(
        Y,
        {
          "aria-hidden": !0,
          style: {
            width: "var(--icon-xs)",
            height: "var(--icon-xs)",
            marginLeft: "var(--space-1)",
            verticalAlign: "-2px"
          }
        }
      )
    ] }) : null
  ] }) : t === "loading" ? /* @__PURE__ */ c("div", { ref: v, "data-ls-component": "draft-panel", "data-mode": t, style: h, children: [
    /* @__PURE__ */ e(w, { style: b, children: r?.kicker }),
    /* @__PURE__ */ c("div", { role: "status", "aria-live": "polite", "aria-label": r?.loadingLabel, children: [
      /* @__PURE__ */ e(T, { variant: "rect", height: 16 }),
      /* @__PURE__ */ e("div", { style: { height: "var(--space-2)" } }),
      /* @__PURE__ */ e(T, { variant: "rect", height: 16, width: "80%" }),
      /* @__PURE__ */ e("div", { style: { height: "var(--space-2)" } }),
      /* @__PURE__ */ e(T, { variant: "rect", height: 16, width: "60%" })
    ] })
  ] }) : t === "auto" ? /* @__PURE__ */ c(
    "div",
    {
      ref: v,
      "data-ls-component": "draft-panel",
      "data-mode": t,
      style: { ...h, position: "relative" },
      children: [
        /* @__PURE__ */ e(w, { style: b, children: r?.autoSentLabel }),
        n !== null ? /* @__PURE__ */ e(
          "p",
          {
            style: {
              margin: 0,
              padding: "var(--space-3)",
              background: "var(--bg-base)",
              border: "1px solid var(--border-subtle)",
              borderRadius: "var(--radius-lg)",
              color: "var(--text-secondary)",
              whiteSpace: "pre-wrap"
            },
            children: n
          }
        ) : null,
        /* @__PURE__ */ e(
          C,
          {
            withExternalLinkIcon: !1,
            onOpenInBarel: y,
            onDismiss: m,
            openInBarelLabel: r?.openInBarel,
            dismissLabel: r?.dismiss
          }
        )
      ]
    }
  ) : /* @__PURE__ */ c(
    "div",
    {
      ref: v,
      "data-ls-component": "draft-panel",
      "data-mode": t,
      "data-hot": f || void 0,
      style: { ...h, position: "relative" },
      children: [
        /* @__PURE__ */ e(w, { style: f ? q : b, children: r?.kicker }),
        f ? /* @__PURE__ */ e(g, { tone: "error", title: r?.kicker, children: r?.accountMismatchBody ?? null }) : null,
        a && !f ? /* @__PURE__ */ e(g, { tone: "warning", title: r?.blockedTitle, children: r?.blockedBody ?? null }) : null,
        /* @__PURE__ */ e(
          K,
          {
            ref: _,
            value: n ?? "",
            onChange: W,
            onKeyDown: F,
            ariaLabel: r?.draftTextareaAriaLabel,
            streaming: d
          }
        ),
        /* @__PURE__ */ e($, { text: n ?? "", streaming: d }),
        o && o.length > 0 ? /* @__PURE__ */ e("ul", { style: J, children: o.map((p, M) => /* @__PURE__ */ e("li", { style: Q, children: p }, `${M}-${p}`)) }) : null,
        O ? /* @__PURE__ */ e(
          P,
          {
            isHot: f,
            sendDisabled: s,
            streaming: d,
            onSend: L,
            onRegenerate: z,
            onRewrite: H,
            sendLabel: r?.send,
            regenerateLabel: r?.regenerate,
            rewriteLabel: r?.rewrite
          }
        ) : null,
        /* @__PURE__ */ e(
          C,
          {
            withExternalLinkIcon: !0,
            onOpenInBarel: y,
            onDismiss: m,
            openInBarelLabel: r?.openInBarel,
            dismissLabel: r?.dismiss
          }
        )
      ]
    }
  );
});
te.displayName = "DraftPanel";
export {
  te as D,
  $ as a
};
//# sourceMappingURL=DraftPanel-D8oLzs1A.js.map
